import React, { useState } from "react";
import { InlineMath } from 'react-katex';
import { formulaData } from "./FormulaSearchData";
import { imageNames } from "./imageList"; // Import image names

const FormulaSearch = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [visibleCount, setVisibleCount] = useState(5); // Lazy loading formulas
    const [zoomedImage, setZoomedImage] = useState(null); // Store the clicked image

    // Filter formulas based on search term
    const filteredData = formulaData.filter((item) => {
        const lowerSearch = searchTerm.toLowerCase();
        return (
            item.level.toLowerCase().includes(lowerSearch) ||
            item.title.toLowerCase().includes(lowerSearch) ||
            item.formula.some((f) => f.toLowerCase().includes(lowerSearch))
        );
    });

    // Filter images based on search term
    const filteredImages = imageNames.filter((name) =>
        name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="max-w-3xl mx-auto p-4">
            <h1 className="text-2xl font-bold mb-4">Formula Search</h1>

            {/* Search Input */}
            <input
                type="text"
                placeholder="Search formulas or tables..."
                className="w-full mb-4 p-2 border border-gray-300 rounded"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
            />

            {/* Image Results */}
            {filteredImages.length > 0 && (
                <div className="mb-6">
                    <h2 className="text-lg font-semibold">Matching Tables</h2>
                    <div className="grid grid-cols-2 gap-4">
                        {filteredImages.map((img, idx) => (
                            <div key={idx} className="border p-2 rounded">
                                <img src={`/tables/${encodeURIComponent(img)}`} alt={img} className="w-full h-auto"                                     onClick={() => setZoomedImage(`/tables/${encodeURIComponent(img)}`)}
                                />
                                <p className="text-sm text-center mt-1">{img.replace(/\.png$/, "")}</p>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Formula Results */}
            {filteredData.length === 0 ? (
                <p className="text-gray-500">No formulas found.</p>
            ) : (
                <div className="space-y-6">
                    {filteredData.slice(0, visibleCount).map((item, idx) => (
                        <div key={`${item.level}-${item.title}-${idx}`} className="border rounded p-4 shadow-sm">
                            <div className="font-semibold text-lg">{item.level}</div>
                            <div className="text-gray-600 mb-2">{item.title}</div>
                            {item.formula.map((formula, i) => (
                                <div key={i} className="mb-2">
                                    <InlineMath math={`\\[${formula}\\]`}/>
                                </div>
                            ))}
                        </div>
                    ))}
                    {visibleCount < filteredData.length && (
                        <button
                            className="w-full mt-4 p-2 bg-blue-500 text-white rounded"
                            onClick={() => setVisibleCount((prev) => prev + 5)}
                        >
                            Load More
                        </button>
                    )}
                </div>
            )}
                        {zoomedImage && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
                    onClick={() => setZoomedImage(null)}
                >
                    <div className="relative max-w-3xl w-full">
                        <button
                            className="absolute top-4 right-4 bg-white p-2 rounded-full"
                            onClick={() => setZoomedImage(null)}
                        >
                            ✖
                        </button>
                        <img src={zoomedImage} alt="Zoomed" className="w-full h-auto rounded-lg" />
                    </div>
                </div>
            )}
        </div>
    );
};

export default FormulaSearch;
